// Контекст выделенного WebView МП сохраняется на время его сессии
export function getMobileAuthContext(searchParams: URLSearchParams): URLSearchParams {
	const storageKey = "mobile-auth-context";
	if (searchParams.has("mobile")) {
		const context = new URLSearchParams();
		context.set("mobile", "1");
		if (searchParams.has("access_token")) {
			context.set("access_token", searchParams.get("access_token"));
		}
		window.sessionStorage.setItem(storageKey, context.toString());
		return context;
	}

	return new URLSearchParams(window.sessionStorage.getItem(storageKey) || "");
}
